import { createReducer, on } from '@ngrx/store';
import * as ReviewPageActions from './review-page.actions';
import { ReviewPageState } from './review-page.state';

export const initialReviewState : ReviewPageState = {
  reviews: {},
};

export const reviewPageReducer = createReducer(
  initialReviewState,
  on(ReviewPageActions.addReview, (state, { review }) => ({
    ...state,
    reviews: {
      ...state.reviews,
      [review.id]: review,
    },
  })),
  on(ReviewPageActions.addProfile, (state, { profile }) => ({
    ...state,
    profile,
  }))
);


